import { useEffect, useState, useRef } from "react";
import { Config } from "../../config/config";
import {
  fetchBrands,
  fetchAgencies,
  fetchAssociations,
} from "../../utils/requests";
import ReactMarkdown from "react-markdown";

const WeWorkMobile = ({ textes, type, setIsBackgroundWhite, isBackgroundWhite }) => {
  const [data, setData] = useState([]);
  const sectionRef = useRef(null);

  const getDatas = () => {
    switch (type) {
      case "brands":
        fetchBrands().then((data) => setData(data.data));
        break;
      case "agencies":
        fetchAgencies().then((data) => setData(data.data));
        break;
      case "associations":
        fetchAssociations().then((data) => setData(data.data));
        break;
      default:
        return "";
    }
  };

  useEffect(() => {
    getDatas();
  }, []);

  const logos = data.map((item) => ({
    id: item.id,
    alt: item.attributes.name,
    src:
      Config.api.mediaUrl +
      item.attributes.logo.data.attributes.formats.thumbnail.url,
  }));

  return (
    logos.length > 0 && (
      <div
        className="w-screen min-h-screen flex flex-col wework-container justify-center items-center"
        style={{ backgroundColor: '#ffffff' }}
        ref={sectionRef}
      >
        <div className="max-w-[1440px] w-full px-4">
          <div className="text-5xl sm:text-5xl md:text-6xl text-left font-bold text-black pt-[5vh] font-lexend relative ml-[5%] mr-[5%] mb-8">
            <ReactMarkdown
              escapeHtml={false}
              components={{
                strong: ({ node, ...props }) => (
                  <span className="centered-text-strong font-sam" {...props} />
                ),
              }}
            >
              {(type === "brands" && textes?.weworkBrands) ||
                (type === "agencies" && textes?.weworkAgencies) ||
                (type === "associations" && textes?.weworkAssociations)}
            </ReactMarkdown>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4 h-full items-center justify-items-center wework-logos-mobile">
            {logos.map((logo) => (
              <img
                key={logo.id}
                src={logo.src}
                alt={logo.alt}
                className="w-25 h-24 object-contain invert"
              />
            ))}
          </div>
        </div>
      </div>
    )
  );
};

export default WeWorkMobile;